import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Container, SimpleGrid, Heading } from "@chakra-ui/react"
import FaqItem from "./FaqItem"

export function Faq() {
  const { dataJson } = useStaticQuery(graphql`
    query {
      dataJson {
        faqs {
          question
          answer
          icon
        }
      }
    }
  `)

  const { faqs } = dataJson

  return (
    <section id="faq">
      <Container>
        <Heading size="3xl" textAlign="center" mb={8} fontWeight="semibold">
          Frequently asked questions
        </Heading>

        <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={16}>
          {faqs.map((item, index) => {
            return <FaqItem key={index} {...item} />
          })}
        </SimpleGrid>
      </Container>
    </section>
  )
}
